<template>
  <div>
    <div class="search-header d-flex justify-content-between align-items-center mb-3">
      <b-nav pills class="mb-3">
        <b-nav-item v-for="(status) in [null, 'sent', 'draft']" :key="status" :active="filter.status === status" @click="filter.status = status">
          {{status ? $t(status) : 'すべて'}}({{emailCount(status)}})
        </b-nav-item>
      </b-nav>
      <div class="search-bar">
        <b-nav-form>
          <b-form-input placeholder="サイト内を検索" class="py-2 mr-1" type="search" v-model="filter.name"></b-form-input>
          <b-button class="search-btn px-4 ml-n2" variant="secondary" type="button">
              <b-icon icon="search" scale="1"></b-icon>
          </b-button>
        </b-nav-form>
      </div>
    </div>
    <div class="responsive-table">
        <div class="responsive-table">
        <b-table id="my-table" head-variant="p-3 mb-2 bg-light text-dark" responsive bordered
            :items="filteredMagazine"
            :per-page="perPage"
            :current-page="currentPage"
            :fields="fields"
            select-mode="single"
            selectable
            @row-selected="onRowSelected"
            hover
        >
            <template #cell(subject)="row">
                <router-link class="text-dark" :to="'/administrator/edit-email/' + row.item.id"> {{ row.value }}</router-link>
            </template>
        </b-table>
    </div>
    </div>
    <div>
        <div class="m-4">
        <b-pagination align="center" size="lg" class="position-relative"
            v-model="currentPage"
            :total-rows="filteredMagazine.length"
            :per-page="perPage"
            :limit="4"
            :show-step-links="true"
            aria-controls
            first-number
            last-number
            v-show="pages"
        >
        <template #prev-text><span><b-icon icon="chevron-left" scale="1.5"></b-icon></span></template>
        <template #next-text><span><b-icon icon="chevron-right" scale="1.5"></b-icon></span></template>
        </b-pagination>
        </div>
    </div>
 </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      fields: [
        { key: 'subject', label: '件名', thStyle: { background: '#F8F9FA' } },
        {
          key: 'published_status',
          label: 'ステータス',
          formatter: value => {
            return this.$i18n.t(value)
          }
        },
        {
          key: 'language',
          label: '宛先',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return this.$i18n.t(`email-target:${value}`)
          }
        },
        {
          key: 'delivered_at',
          label: '配信日',
          thStyle: { background: '#F8F9FA' },
          formatter: value => {
            return value.substring(0, 10).replace(/-/g, '/')
          }
        }
      ],
      rows: 8,
      perPage: 30,
      allPage: null,
      currentPage: 1,
      paginate: false,
      filter: {
        name: null,
        status: null
      }
    }
  },
  computed: {
    ...mapState('adminMagazine', ['magazine']),
    filteredMagazine: function () {
      return this.magazine.data
        .filter(this.searchByName)
        .filter(this.filterByPageStatus)
    },
    pages: function () {
      if (this.filteredMagazine.length <= 30) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions('adminMagazine', ['allMagazine']),
    searchByName: function (magazine) {
      if (this.filter.name === null || this.filter.name === '') {
        return true
      }
      return (magazine.subject.toLowerCase().indexOf(this.filter.name.toLowerCase()) >= 0)
    },
    filterByPageStatus: function (magazine) {
      if (this.filter.status === null) {
        return true
      }
      return (magazine.published_status === this.filter.status)
    },
    onRowSelected (items) {
      this.$router.push({ name: 'E-mail magazine editing', params: { id: items[0].id } })
    },
    emailCount: function (status) {
      if (status === null) return this.magazine.data.length

      return this.magazine.data.filter((magazine) => {
        return (magazine.published_status === status)
      }).length
    }
  }
}
</script>
